<!--
우편번호 검색 컴포넌트 > 기본버튼 템플릿
---------------------------------------
사이즈 변경필요하면 uk-button-small 이런 사이즈 클래스 지정하면됨
-->
<template>
    <button
        class="uk-button uk-button-white"
        type="button"
        @click="search"
        :disabled="loadState === 'loading'"
    >
        <span v-show="loadState === 'loading'">
            <loading-icon
                class="uk-text-middle"
                bg-color="#ccc"
                fore-color="#333"
            ></loading-icon>
            loading...
        </span>

        <span v-show="loadState !== 'loading'">
            <i class="material-icons">search</i>
            우편번호검색
        </span>

    </button>
</template>

<script>
    import Base from './base.vue';

    export default {
        extends: Base,
        components: {
            'loading-icon': require('../common/loading-icon.vue').default,
        },
    }
</script>

<style lang="scss" scoped>
</style>